import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

/* ================================
   DASHBOARD APIS (FormData Based)
   Controller: Dashcon.php
================================= */

/* ✅ 1) Dashboard Stats */
export const getDashboardStats = async (admin_id) => {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id || "");

    const res = await axios.post(`${apiBaseUrl}dashcon/get_dashboard_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
};

/* ✅ 2) Recent Requests */
export const getRecentRequests = async (admin_id) => {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id || "");

    const res = await axios.post(`${apiBaseUrl}dashcon/get_recent_requests`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
};

export const exportDashboardReportXl = async (payload) => {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");

    const res = await axios.post(`${apiBaseUrl}dashcon/export_dashboard_report_xl`, fd, {
      responseType: "blob",
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res;
  } catch (e) {
    return null;
  }
};
